import React from 'react';
import { visa, mastercard, amex } from 'roo-ui/assets';
import { Flex, Image } from 'roo-ui/components';

export const amexImage = {
  src: amex,
  alt: 'amex credit card image',
};

export const mastercardImage = {
  src: mastercard,
  alt: 'mastercard credit card image',
};

export const visaImage = {
  src: visa,
  alt: 'visa credit card image',
};

const CreditCardIcons = () => {
  return (
    <Flex alignItems="center">
      <Image src={visaImage.src} alt={visaImage.alt} width={34} height={24} mr={1} data-testid="visa_card_image" />
      <Image src={mastercardImage.src} alt={mastercardImage.alt} width={34} height={24} mr={1} data-testid="mastercard_card_image" />
      <Image src={amexImage.src} alt={amexImage.alt} width={34} height={24} data-testid="amex_card_image" />
    </Flex>
  );
};

CreditCardIcons.displayName = 'CreditCardIcons';

export default CreditCardIcons;
